import { useCallback, useState } from 'react';
import { useLoadImageInMemory, LoadImageProps } from '../../utils/useLoadImageInMemory';
import { useIntersectionObserver } from '../../utils/useIntersectionObserver';

export function useLazyLoadingImage(props: LoadImageProps, loading: 'lazy' | 'eager') {
  const enabledLazyLoading = loading === 'lazy' && (!!props.src || !!props.srcSet);
  const [enabledLoadingInMemory, setEnabledLoadingInMemory] = useState(!enabledLazyLoading);

  const { imgProps, loading: loadingInMemory, finished, error } = useLoadImageInMemory(props, !enabledLoadingInMemory);

  const ref = useIntersectionObserver({
    options: {
      disabled: !enabledLazyLoading,
      rootMargin: '100px 0px 100px 0px'
    },
    callback: useCallback((entries: any) => {
      entries.forEach((entry: any) => {
        if (entry.isIntersecting) {
          setEnabledLoadingInMemory(true);
        }
      });
    }, [])
  });

  return {
    ref,
    imgProps,
    loadingInMemory,
    finished,
    error
  };
}
